import React from 'react';

// components
import InUseContents from './LwInUseContents';
import UnConnectedContents from './LwUnConnectedContents';
import { LineWorksLogo } from '../icons/LineWorksLogo';
import { Description } from '../Description';

// utilities
import { LINE_WORKS_STATUS_CODE } from '../../utilities/constants';
import { messageUtility } from '../../utilities/messageUtility';

function isShowLwDescription(status_code) {
  switch (status_code) {
    case LINE_WORKS_STATUS_CODE.ERROR:
      return false;
    case LINE_WORKS_STATUS_CODE.INUSE:
      return true;
    case LINE_WORKS_STATUS_CODE.UNUSE:
      return false;
    case LINE_WORKS_STATUS_CODE.UNCONNECTED:
      return true;
  }
}

function showContents(status_code) {
  switch (status_code) {
    // 予期しないエラー
    case LINE_WORKS_STATUS_CODE.ERROR:
      return null;
    // 設定済みであり、正常に利用可能
    case LINE_WORKS_STATUS_CODE.INUSE:
      return <InUseContents />;
    // LINE WORKS連携の利用が許可されていない
    case LINE_WORKS_STATUS_CODE.UNUSE:
      return null;
    // 現場とLINE WORKSの連携が未実施である
    case LINE_WORKS_STATUS_CODE.UNCONNECTED:
      return <UnConnectedContents />;
  }
}

export default function LwDescription({ status_code }) {
  return (
    <React.Fragment>
      {isShowLwDescription(status_code) ? (
        <Description>
          <div className='ExternalServiceCooperation__service-name'>
            <LineWorksLogo height={24} />
          </div>
          <div className='ExternalServiceCooperation__contents'>
            {showContents(status_code)}
          </div>
          <div className='ExternalServiceCooperation__bar' />
          <div className='ExternalServiceCooperation__info-text'>
            {messageUtility.getMessage('I-001-523')}
          </div>
        </Description>
      ) : null}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/LwDescription.jsx